import React from "react";
import useTranslation from "../../hooks/translation-hook";
import {
  AGE_RESTRICTED_DARK_COLOR,
  AGE_RESTRICTED_PRIMARY_COLOR,
} from "../map/ageRestrictedPin";
import AgeRestrictedMissionIcon from "../common/mission/AgeRestrictedMissionIcon";
import MissionPromotionPopup from "./MissionPromotionPopup";

export interface AgeRestrictedMissionsPopupProps {
  onClose?(dontShowAgain: boolean): void;
  onProceed?(dontShowAgain: boolean): void;
}

const AgeRestrictedMissionsPopup = (props: AgeRestrictedMissionsPopupProps) => {
  const t = useTranslation();

  return (
    <MissionPromotionPopup
      title={t("age-restricted-promotion-title")}
      subtitle={t("age-restricted-promotion-subtitle")}
      ctaLabel={t("age-restricted-promotion-cta")}
      dontShowLabel={t("age-restricted-promotion-dont-show")}
      checkboxValue="dontShowAgeRestrictedMissions"
      backgroundColor={AGE_RESTRICTED_PRIMARY_COLOR}
      backgroundGradientColors={[
        "#8B5CF6",
        AGE_RESTRICTED_PRIMARY_COLOR,
        "#6D28D9",
      ]}
      backgroundDecorationColor="rgba(255, 255, 255, 0.08)"
      buttonColor={AGE_RESTRICTED_DARK_COLOR}
      buttonBorderColor="rgba(255, 255, 255, 0.18)"
      buttonShadowColor="#2E1065"
      checkboxTextColor="#EEE7FF"
      checkboxBorderColor="#A78BFA"
      checkboxBackgroundColor="#F8F5FF"
      icon={
        <AgeRestrictedMissionIcon
          size={50}
          color="#FFFFFF"
        />
      }
      iconContainerStyle={{ width: 50 }}
      iconContentLeftPadding={86}
      borderColor="rgba(255, 255, 255, 0.24)"
      shadowColor="#2E1065"
      titleFontSize={19}
      subtitleFontSize={14}
      onClose={props.onClose}
      onProceed={props.onProceed}
    />
  );
};

export default AgeRestrictedMissionsPopup;
